import { Order } from '../apollo/graphqlSchema';
import { IconName } from '../../components/Icon';

export const orderIconLookup: Record<Order, IconName> = {
  [Order.Asc]: 'ascending-button',
  [Order.Desc]: 'descending-button',
};
